module.exports = __webpack_public_path__ + "img/partners.27737de7.jpg";